import { render, staticRenderFns } from "./wl-trust-badges.vue?vue&type=template&id=7b3c4cd2"
import script from "./wl-trust-badges.vue?vue&type=script&lang=js"
export * from "./wl-trust-badges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0_supports-color@5.5.0___css-loader@_ae2ff0065f9e281cb79b0d4a64c16116/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports